import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { ShishinInputTab, SuppntInfo } from 'sg-api';

@Component({
  selector: 'app-sgke360d-button-area',
  templateUrl: './sgke360d-button-area.component.html',
  styleUrl: './sgke360d-button-area.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke360dButtonAreaComponent implements OnInit, OnDestroy {
  /** 基本情報のレスポンス */
  @Input() suppntInfo: SuppntInfo = null;
  /** ボタン押下イベント */
  @Output() onClickButtonEvent = new EventEmitter<string>();
  /** 親フォームグループ */
  parentForm: UntypedFormGroup;

  /**
   * コンストラクタ
   * @param {FormGroupDirective} parent
   * @memberof Sgke360dButtonAreaComponent
   */
  constructor(
    private parent: FormGroupDirective,
  ) { }

  /** 初期化処理 */
  ngOnInit(): void {
    this.parentForm = this.parent.form;
  }
  /** 終了処理 */
  ngOnDestroy(): void {

  }
  /** 登録ボタンバリデーション */
  public get invalidResistButton() {
    // 一般供給再開
    const isIppan = this.suppntInfo?.workClscode == '2'
    // 作業結果ラジオボタン（供給停止再開結果区分コード）
    const resultDiv = this.getControl('supplystopresumptionResultDivcd').value;

    let requiredList;
    // 作業結果
    switch (resultDiv) {
      // 完了
      case '0':
        if (isIppan) {
          // 一般供給再開
          // マイコンメータフラグ
          const isMicon = this.suppntInfo?.meterBunruiCode == '02';

          requiredList = [
            // メーター外観異常
            { control: 'meterExteriorAbnormalflag', value: '0', enable: true },
            // メータガス栓異常 供給停止時メータガス栓閉止フラグはバリデーションで実施
            { control: 'meterGassenAbnormalflag', value: null, enable: true },
            // マイコンメーターテスト遮断異常
            { control: 'microcontrollermeterTestblockAbnormalflag', value: '0', enable: isMicon  },
            // マイコンメーター復帰異常
            { control: 'microcontrollermeterReturnAbnormalflag', value: '0', enable: isMicon },

            // 一般供給再開
            // 漏洩検査・圧力
            { control: 'leaktestAtrk', value: null, enable: true  },
            // 漏洩検査・時間
            { control: 'leaktestTime', value: null, enable: true  },

            // 確認結果
            { control: 'leaktestConfirmationresultFlg', value: '1', enable: true },
            // 指針値
            { control: 'onresumptionShishin', value: null, enable: true },
            // 非安全機器周知フラグ
            { control: 'unsafeDeviceNoticeflag', value: '1', enable: this.getControl('unsafeDeviceNoticeflag').enabled },
            // 点火試験済フラグ
            { control: 'lightingExaminedFlg', value: null, enable: true },
          ];
        } else {
          // 簡易供給再開
          // 現地作業
          const isField = this.getControl('workPlaceCode').value != '2';
          // マイコンメータ有無フラグ
          const isMicon = this.getControl('microcontrollermeterUmuFlg').value != '0';

          requiredList = [
            // 現地作業
            { control: 'workPlaceCode', value: null, enable: true },
            // マイコンメータ有無フラグ
            { control: 'microcontrollermeterUmuFlg', value: null, enable: isField },
            // メーター外観異常
            { control: 'meterExteriorAbnormalflag', value: '0', enable: isMicon && isField },
            // メータガス栓異常 供給停止時メータガス栓閉止フラグはバリデーションで実施
            { control: 'meterGassenAbnormalflag', value: null, enable: isMicon && isField },
            // マイコンメーターテスト遮断異常
            { control: 'microcontrollermeterTestblockAbnormalflag', value: '0', enable: isMicon && isField },
            // マイコンメーター復帰異常
            { control: 'microcontrollermeterReturnAbnormalflag', value: '0', enable: isMicon && isField },

            // 簡易供給再開
            // 動止確認漏洩検査可否
            { control: 'operationcheckLeaktestKahiflg', value: '1', enable: isMicon && isField },
            // メーター指針動止確認コード
            { control: 'meterShishinstartandstopConfirmationcode', value: null, enable: isMicon && isField },
            // チラシ投函フラグ
            { control: 'flyerPostingFlg', value: '1', enable: isField },

            // 確認結果
            { control: 'leaktestConfirmationresultFlg', value: '1', enable: isMicon && isField },
            // 指針値
            { control: 'onresumptionShishin', value: null, enable: isMicon && isField },
          ];
        }
        requiredList = [
            ...requiredList,
            // 作業結果
            { control: 'supplystopresumptionResultDivcd', value: null, enable: true },
            // 供給再開日付
            { control: 'supplyresumptionDate', value: null, enable: true },
            // 供給再開時刻
            { control: 'supplyresumptionHms', value: null, enable: true },
        ];
        break;
      // 延期
      case '1':
        requiredList = [
          // 作業結果
          { control: 'supplystopresumptionResultDivcd', value: null, enable: true },
          // 変更後供給再開予定日付
          { control: 'afSupplyresumptionScddt', value: null, enable: true },
          // 変更後供給再開予定時間帯
          { control: 'afSupplyresumptionYtitimez', value: null, enable: true },
        ];
        break;
      // 再開中止、他
      default:
        requiredList = [
          // 作業結果
          { control: 'supplystopresumptionResultDivcd', value: null, enable: true },
        ];
        break;
    }

    // 一つでもNGがあればdisableにする
    return requiredList.some((req) => {
      const ctl = this.getControl(req.control);
      let ret: boolean = false;
      // 有効な場合のみチェック
      if (req.enable) {
        // 比較対象が設定されている場合は入力値との比較、それ以外はバリデーションチェック
        ret = req.value ? ctl.value !== req.value : ctl.invalid;
      }
      return ret;
    });
  }
  /**
   * 中断ボタンバリデーション
   *
   * @readonly
   * @memberof Sgke360dButtonAreaComponent
   */
  public get invalidCancelButton() {

    const requiredList = [
      // 点検業務引継先コード
      { control: 'inspectiontaskTakeovertoCode', value: null, enable: true },
    ];

    // 一つでもNGがあればdisableにする
    return requiredList.some((req) => {
      const ctl = this.getControl(req.control);
      let ret: boolean = false;
      // 有効な場合のみチェック
      if (req.enable) {
        // 比較対象が設定されている場合は入力値との比較、それ以外はバリデーションチェック
        ret = req.value ? ctl.value !== req.value : ctl.invalid;
      }
      return ret;
    });
  }

  /**
   * コントロール取得
   *
   * @private
   * @param {*} ctlName コントロール名
   * @return {*} コントロール
   * @memberof Sgke360dButtonAreaComponent
   */
  private getControl(ctlName) {
    const supplyForm = this.parentForm.controls['supplyresumptionResultInfo'] as UntypedFormGroup;
    return supplyForm.controls[ctlName];
  }
}
